import dayjs from 'dayjs';
import React, { useState } from 'react';
import { useTemplate } from '../../../../features/template/TemplateProvider';
import useApi from '../../../../hook/useApi';
import { ButtonCancel, ButtonPrimary } from '../../../../utils/Button';
import FocusControl from '../../../../utils/FocusControl';
import { InputDateField } from '../../../../utils/InputField';

function InfoRow({ title, value }) {
    return (
        <div className="flex flex-row justify-start items-center gap-1 text-primary-700 mb-1 pl-2">
            <span className="whitespace-nowrap w-11">{title}</span>
            <span className="text-primary-700">:&nbsp;</span>
            <span className="text-primary font-medium capitalize">{value}</span>
        </div>
    );
}
function ProductDetails({ data }) {
    return (
        <div className="content-part flex flex-col gap-1 items-start overflow-hidden mb-2 border-b pb-2 w-full">
            {/* <div className="w-11 min-w-[44px]  h-11">
                <img src={data.logoUrl || menuIcon.settingsWL} alt="" className="w-full block" />
            </div> */}
            <div className="flex flex-row items-center gap-3">
                <span className="inline-block text-primary text-lg font-medium">
                    {data?.productTitle}
                </span>
            </div>
            <p className="text-sm text-primary-700">{data?.packageName}</p>
        </div>
    );
}

function ModalPendingServiceInitialize() {
    const { closeModal, modalData } = useTemplate();
    const [loading, setLoading] = useState(false);
    const [isError, setIsError] = useState('');
    const { post } = useApi();
    const invoiceId = modalData?.item?.invoiceId || 0;
    const [formData, setFormData] = useState({
        InvoiceId: invoiceId,
        InvoiceItemId: modalData?.item?.invoiceItemId || 0,
        ServiceStartDate:
            modalData?.item?.subscriptionStart !== 0
                ? dayjs(modalData.item.subscriptionStart * 1000).format('YYYY-MM-DD')
                : dayjs().format('YYYY-MM-DD')
    });
    console.log(formData);
    // // handle input change
    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name) {
            setFormData((d) => ({ ...d, [name]: value }));
        }
    };
    const { setMessage } = useTemplate();

    const handleOnSubmit = (e) => {
        e.preventDefault();
        setLoading(true);
        // api/services-progress/initiate/${invoiceId}/${invoiceItemId}
        post(
            `/api/services-progress/initiate/${formData?.InvoiceId}/${formData?.InvoiceItemId}`,
            formData
        )
            .then(({ error, message, referenceName }) => {
                if (error) {
                    setIsError(referenceName);
                    throw new Error(message);
                }
                setMessage({ type: 'success', text: message });
                modalData?.handleReload();
                closeModal();
            })
            .catch((err) => {
                setMessage({ type: 'error', text: err?.message });
            })
            .finally(() => {
                setLoading(false);
            });
    };

    FocusControl(isError, setIsError, formData);

    return (
        <form onSubmit={handleOnSubmit}>
            <div className="flex flex-col overflow-hidden transition-all duration-500">
                <ProductDetails data={modalData?.item || {}} />
                {/* <InfoRow
                    title="Price"
                    value={`${GetCurrencySymbol(modalData?.item?.currency)}${GetFloatNumber(modalData?.item?.totalPrice)}`}
                /> */}
                <InfoRow title="Type" value={modalData?.item?.productType} />

                <div className="mb-4 mt-3">
                    <InputDateField
                        label="Service Start Date"
                        name="ServiceStartDate"
                        formData={formData}
                        onChange={handleChange}
                    />
                </div>

                {/* if Fixed then show message */}
                {modalData?.item?.unitName === 'fixed' && (
                    <div className="mb-2 text-sm text-yellow-600">
                        Warning: This is a fixed type service. So, after initializing this service,
                        the service will be automatically suspended after the service period ends.
                    </div>
                )}

                {/* Note: */}
                <div className="mb-4 text-sm text-error">
                    Note: If you initialize this service, then you can&apos;t remove this service
                    item from the invoice later.
                </div>

                <div className="w-full flex justify-end items-center gap-2 mb-2">
                    <ButtonCancel title="Cancel" onClick={() => closeModal()} />
                    <ButtonPrimary title="Initiate" btnType="submit" loading={loading} />
                </div>
            </div>
        </form>
    );
}

export default ModalPendingServiceInitialize;
